import templateUrl from "emun.vendor/vendor-edit.htm";
import angular from "angular";
import ServiceBus from "servicestack/service-bus";
import modals from "webmodals/modals";
import form from "emun.vendor/vendor-edit.formio";
import formioController from "webforms/formio/formio.controller";
import AutoQuery from "servicestack/auto-query/auto-query";

class controller {
constructor($scope, options) {
	const $ctrl = this;
    formioController($ctrl, $scope);
	$ctrl.bus = new ServiceBus();
	$ctrl.form = form;
	$ctrl.formProcessing = false;
    $ctrl.title = options.title || " Vendor Edit...";
	$ctrl.vendor = options.vendor || {};
	if ($ctrl.vendor.tags) {
		$ctrl.submissionId = $ctrl.vendor.tags.EditForm;
	}
	$ctrl.submission = {
		label: "vendor-edit",
		data: {
			vendorId: $ctrl.vendor.id
		}
	};
	if ($ctrl.vendor) {
		Object.assign($ctrl.submission.data, $ctrl.vendor);
		$ctrl.vendor.settings.forEach(function(s) {
			$ctrl.submission.data["VSP_" + s.key] = s.value == "true" ? true : s.value == "false" ? false : s.value;
		}); 
	}
	if ($ctrl.submissionId) {
		$ctrl.bus
			.send(`QueryFormSubmissions/${$ctrl.submissionId}.json`)
			.then(({ data }) => {
				if (data.results.length) {
					$ctrl.submission.data = data.results[0].data;
					Object.assign($ctrl.submission.data, $ctrl.vendor);
					$ctrl.vendor.settings.forEach(function(s) {
						$ctrl.submission.data["VSP_" + s.key] = s.value == "true" ? true : s.value == "false" ? false : s.value;
					}); 
				}
			});
	}
  }

	formSubmission(e, submission) {
		const $ctrl = this;
		console.debug("formSubmission", { $ctrl, e, submission });
		submission.data.vendorId = $ctrl.vendor.id;
		$ctrl.submission = submission;
		$ctrl.$broadcast("$vendorEditSubmitted");
		$ctrl.$dismiss();
	}
}

export default {
  open(options) {
    return modals.open(
      Object.assign(
        {
          templateUrl,
          resolve: {
            options: () => options
          },
          bindToController: true,
          controller,
		  controllerAs: "$ctrl",
		  size: 'lg'
        },
        (options || {}).modal
      )
    ).result;
  }
};
